// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-chip ion-icon[data-v-7b431a0b] {\n  font-size: 24px;\n}\n.chip-disabled[data-v-7b431a0b] {\n  opacity: 1;\n}\nion-icon[data-v-7b431a0b]:last-child {\n  margin-left: unset;\n  margin-right: unset;\n  margin-inline: unset;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
